import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import Icons from "shared/icons";

function RequestLock({ lock }) {
  const { t } = useTranslation("Request");
  return (
    <div className="d-flex align-items-center gap-4">
      <FontAwesomeIcon icon={Icons.circleExclamation} />
      <span>
        {t("request_is_locked_by")}
        <strong>{lock?.holder_full_name}</strong>
      </span>
    </div>
  );
}

export default RequestLock;
